import styled from 'styled-components';

export const FrameDivider = styled.div`
  margin-top: 20px;
`;
